import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import AdmissionReportTemplateFields from './AdmissionReportTemplateFields'

export const AdmissionReportTemplateCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <AdmissionReportTemplateFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default AdmissionReportTemplateCreate
